import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsuarioEmpresaListarComponent } from './usuario-empresa-listar.component';

import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { HttpClientModule } from '@angular/common/http';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from "primeng/tooltip";
import { DividerModule } from 'primeng/divider';

@NgModule({
 
  imports: [
    CommonModule,    
    TableModule,
    HttpClientModule,
    ButtonModule,
    InputTextModule,
    TooltipModule,
    DividerModule
  ],
  declarations: [
    UsuarioEmpresaListarComponent
  ],
  exports: [
    UsuarioEmpresaListarComponent
  ]
})
export class UsuarioEmpresaListarModule { }
